export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Bold.86a7bd8885be971c546c2fe3e702e86b.ttf";